import { observer } from 'mobx-react';
import i_ from 'i18next';
import React from 'react';

import Table from '../commons/Table';

import AuthenticationStore from '../../stores/AuthenticationStore';
import Stores from '../../stores/Stores';
import UIStore from '../../stores/UIStore';

import Edit from './Edit';

const store = Stores.load('usuario');

class Usuario extends React.Component {
  componentWillMount() {
    UIStore.init(i_.t('usuario.title'), store);
  }

  handleDelete = () => {
    let count = store.selected.length;

    UIStore.showConfirmDialog(
      i_.t('dialogs.remove-message', { count }),
      i_.t('dialogs.remove-title', { entity: 'usuario' })
    ).then(b => {
      if (b) {
        store.delete().then(() => store.query());
      }
    });
  };

  render() {
    return (
      <div>
        <Table
          columns={[
            { label: i_.t('usuario.nome'), field: 'nome' },
            { label: i_.t('usuario.email'), field: 'email' },
            { label: i_.t('usuario.perfil'), field: 'perfil.nome' },
            {
              label: i_.t('usuario.cargos'),
              field: 'cargos',
              name: 'nome',
            },
          ]}
          store={store}
          data={store.list}
          selected={store.selected}
          onAdd={() =>
            store.new({
              nome: '',
              email: '',
              perfil: '',
            })
          }
          onEdit={() => store.open()}
          onDelete={() => this.handleDelete()}
        />
        <Edit onSave={() => AuthenticationStore.testAuthenticated()} />
      </div>
    );
  }
}

export default observer(Usuario);



// WEBPACK FOOTER //
// ./src/components/usuario/index.js